// Pure logic for the bulk-store checkout wizard. Framework-free and
// side-effect-free so it can be unit-tested (repo convention: logic lives in
// src/helpers/ with a co-located *.test.js; components stay thin).

export const RECEIVE_CHOICE = { PICKUP: "pickup", SHIP: "ship" };

// Which wizard steps exist for a given dropship mode.
export function deriveSteps(dropship) {
  return dropship === "optional" || dropship === "required"
    ? ["shipping", "review"]
    : ["review"];
}

// Whether the submitted payload carries a shippingAddress. Gated on the explicit
// mode/choice, NEVER on whether ship-to fields happen to be filled, so a
// Ship -> fill -> Back -> Pick-up transition cannot leak a stale address.
export function shouldIncludeShippingAddress(dropship, receiveChoice) {
  if (dropship === "required") return true;
  if (dropship === "optional") return receiveChoice === RECEIVE_CHOICE.SHIP;
  return false;
}

// Defaults used to prefill the purchaser (Review) fields from the ship-to
// contact. Empty strings when there is no ship-to.
export function resolvePurchaserDefaults(shipTo) {
  return { name: shipTo?.name || "", email: shipTo?.email || "" };
}

// Build the exact payload passed to onSubmit (and onward to the unchanged
// http-submitBulkEventOrder callable). For none / optional-pickup the result is
// { po, name, email } with NO shippingAddress key.
export function buildSubmitPayload({ dropship, receiveChoice, shipTo, review }) {
  const payload = { po: review.po, name: review.name, email: review.email };
  if (shouldIncludeShippingAddress(dropship, receiveChoice)) {
    payload.shippingAddress = shipTo;
  }
  return payload;
}

// 1234567890 -> 123-456-7890. Ported from ShippingConfirmation so it is testable.
export function formatPhoneNumber(value) {
  const digits = (value || "").replace(/[^\d]/g, "");
  if (digits.length < 3) return digits;
  if (digits.length < 6) return `${digits.slice(0, 3)}-${digits.slice(3)}`;
  return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6, 10)}`;
}

export function isValidPhone(value) {
  return /^\d{3}-\d{3}-\d{4}$/.test(value || "");
}

export function isValidEmail(value) {
  return /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test((value || "").trim());
}
